// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "voice_receptionist_call".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { voiceCallDirectionValues, voiceCallRouteValues, voiceReceptionistCallStatusValues } from '@borradh-workspace/labels';
/** Response atom for the "voice_receptionist_call" table (1:1 with a DB row, on the wire). */
export const voiceReceptionistCallAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string().nullable(),
    conversationId: z.string().nullable(),
    leadId: z.string().nullable(),
    phoneNumberId: z.string().nullable(),
    direction: z.enum(voiceCallDirectionValues),
    route: z.enum(voiceCallRouteValues).nullable(),
    status: z.enum(voiceReceptionistCallStatusValues),
    fromNumber: z.string().nullable(),
    toNumber: z.string().nullable(),
    startedAt: z.string().datetime().nullable(),
    endedAt: z.string().datetime().nullable(),
    durationMs: z.number().nullable(),
    disconnectionReason: z.string().nullable(),
    usageSeconds: z.number().nullable(),
    recordingSid: z.string().nullable(),
    recordingKey: z.string().nullable(),
    recordingDurationSeconds: z.number().nullable(),
    recordingStoredAt: z.string().datetime().nullable(),
    recordingDeletedAt: z.string().datetime().nullable(),
    metadata: z.unknown().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=voiceReceptionistCall.js.map